import { render, staticRenderFns } from "./Article1.vue?vue&type=template&id=769c7a27&"
import script from "./Article1.vue?vue&type=script&lang=js&"
export * from "./Article1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports